import React from "react";
import Valide from '../assets/images/valide.svg';
import { useNavigate } from 'react-router-dom';
import Header from "./Header";
import { useTranslation } from 'react-i18next';


const PhoneConfirmation = () => {
    const { t } = useTranslation('phone');

    const navigate = useNavigate();

    const handleContinueClick = () => {
        const redirectAfterLogin = sessionStorage.getItem('redirectAfterLogin');
        const storedState = sessionStorage.getItem('state');

        if (redirectAfterLogin) {
            const state = storedState ? JSON.parse(storedState) : null;
            navigate(redirectAfterLogin, { state });
        } else {
            navigate('/');
        }
    };
    return (
        <>
            <Header />

            <div className="phone-confirmation">
                <h2 className="verification">
                    {t('phone:verification')}<br />
                </h2>
            </div>
            <div className="content-wrap">
                <div className="list-item-with-image">
                    <div className="title">
                        <img
                            className="https-app"
                            alt="Https app"
                            src={Valide}
                        />
                        <div className="text-wrapper"> {t('phone:done')}</div>
                    </div>
                </div>

                <div className="buttons">
                    <button className="btn" onClick={handleContinueClick}>
                        {t("phone:continuer")}
                    </button>
                </div>
            </div>
        </>
    );
};


export default PhoneConfirmation;
